import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail } from "lucide-react";

export default function SiteFooter() {
  return (
    <footer data-upbo-src="src/components/SiteFooter.tsx:6" className="border-t border-border bg-background">
      <div data-upbo-src="src/components/SiteFooter.tsx:7" className="container-page flex flex-col gap-10 py-12 md:flex-row md:items-start md:justify-between">
        <div data-upbo-src="src/components/SiteFooter.tsx:8" className="max-w-xs">
          <Link to="/" className="text-lg font-bold tracking-tight text-foreground">
            LumiSkin
          </Link>
          <p data-upbo-src="src/components/SiteFooter.tsx:12" className="mt-3 text-sm leading-relaxed text-muted-foreground">
            Chăm sóc làn da tối giản với công thức thuần khiết, hiệu quả được kiểm chứng — vẻ đẹp tự nhiên không cần che đậy.
          </p>
          <div data-upbo-src="src/components/SiteFooter.tsx:15" className="mt-5 flex items-center gap-4">
            <a data-upbo-src="src/components/SiteFooter.tsx:16" href="#" aria-label="Instagram" className="text-muted-foreground transition-colors hover:text-foreground">
              <Instagram className="h-5 w-5" />
            </a>
            <a data-upbo-src="src/components/SiteFooter.tsx:19" href="#" aria-label="Facebook" className="text-muted-foreground transition-colors hover:text-foreground">
              <Facebook className="h-5 w-5" />
            </a>
            <a data-upbo-src="src/components/SiteFooter.tsx:22" href="mailto:hello@lumiskin.vn" aria-label="Email" className="text-muted-foreground transition-colors hover:text-foreground">
              <Mail className="h-5 w-5" />
            </a>
          </div>
        </div>

        <div data-upbo-src="src/components/SiteFooter.tsx:28" className="grid grid-cols-2 gap-8 sm:grid-cols-3">
          <div data-upbo-src="src/components/SiteFooter.tsx:29">
            <h4 data-upbo-src="src/components/SiteFooter.tsx:30" className="text-xs font-semibold uppercase tracking-[0.1em] text-muted-foreground">
              Khám phá
            </h4>
            <ul data-upbo-src="src/components/SiteFooter.tsx:33" className="mt-4 space-y-3 text-sm">
              <li data-upbo-src="src/components/SiteFooter.tsx:34">
                <Link to="/shop" className="text-foreground transition-colors hover:text-muted-foreground">
                  Cửa hàng
                </Link>
              </li>
              <li data-upbo-src="src/components/SiteFooter.tsx:39">
                <Link to="/about" className="text-foreground transition-colors hover:text-muted-foreground">
                  Về LumiSkin
                </Link>
              </li>
              <li data-upbo-src="src/components/SiteFooter.tsx:44">
                <Link to="/contact" className="text-foreground transition-colors hover:text-muted-foreground">
                  Liên hệ
                </Link>
              </li>
            </ul>
          </div>
          <div data-upbo-src="src/components/SiteFooter.tsx:51">
            <h4 data-upbo-src="src/components/SiteFooter.tsx:52" className="text-xs font-semibold uppercase tracking-[0.1em] text-muted-foreground">
              Hỗ trợ
            </h4>
            <ul data-upbo-src="src/components/SiteFooter.tsx:55" className="mt-4 space-y-3 text-sm">
              <li data-upbo-src="src/components/SiteFooter.tsx:56">
                <Link to="/contact" className="text-foreground transition-colors hover:text-muted-foreground">
                  Câu hỏi thường gặp
                </Link>
              </li>
              <li data-upbo-src="src/components/SiteFooter.tsx:61">
                <Link to="/contact" className="text-foreground transition-colors hover:text-muted-foreground">
                  Vận chuyển & Trả hàng
                </Link>
              </li>
              <li data-upbo-src="src/components/SiteFooter.tsx:66">
                <Link to="/contact" className="text-foreground transition-colors hover:text-muted-foreground">
                  Chính sách bảo mật
                </Link>
              </li>
            </ul>
          </div>
          <div data-upbo-src="src/components/SiteFooter.tsx:73">
            <h4 data-upbo-src="src/components/SiteFooter.tsx:74" className="text-xs font-semibold uppercase tracking-[0.1em] text-muted-foreground">
              Liên hệ
            </h4>
            <ul data-upbo-src="src/components/SiteFooter.tsx:77" className="mt-4 space-y-3 text-sm text-foreground">
              <li data-upbo-src="src/components/SiteFooter.tsx:78">hello@lumiskin.vn</li>
              <li data-upbo-src="src/components/SiteFooter.tsx:79">+84 28 7100 9898</li>
              <li data-upbo-src="src/components/SiteFooter.tsx:80">TP. Hồ Chí Minh, Việt Nam</li>
            </ul>
          </div>
        </div>
      </div>

      <div data-upbo-src="src/components/SiteFooter.tsx:86" className="border-t border-border">
        <div data-upbo-src="src/components/SiteFooter.tsx:87" className="container-page flex flex-col gap-2 py-5 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <p data-upbo-src="src/components/SiteFooter.tsx:88">© {new Date().getFullYear()} LumiSkin. Tất cả các quyền được bảo lưu.</p>
          <p data-upbo-src="src/components/SiteFooter.tsx:89">Thiết kế tối giản — vì làn da của bạn xứng đáng sự tinh khiết.</p>
        </div>
      </div>
    </footer>
  );
}
